import {Divider, Menu, MenuProps, Modal, Space} from 'antd'
import React, {useEffect, useState} from 'react'
import Input from '../../components/UI/Input'
import {
  AuditOutlined, DeleteOutlined, EditOutlined, EyeOutlined,
  FileTextOutlined,
  HomeOutlined,
  MinusOutlined,
  PlusOutlined,
  PrinterOutlined,
  TagsOutlined, ToolOutlined
} from "@ant-design/icons";
import Button from "../../components/UI/Button";
import List from "../../components/List";
import {compareNumbers, stringCompare} from "../../utils/sorters";
import {sendSystemLog} from "../../context/AuthProvider/useAuth";
import {getAllowCreateNewDevicePermission, getPermission} from "../../services/permisssion";
import permissionType from "../../utils/permissionType";
import {getDevicesList} from "../../services/devices";
import loading from "../../components/UI/Loading";
import {useLoading} from "../../context/LoadingProvider/useLoading";
import {addTag, addTagToDevices, deleteTag, getAllTags, removeTagFromDevices} from "../../services/pttags";

interface modalPTTagsSelectorProps {
  visible: boolean
  title: string
  tags: string[],
  allTags: string[]
  onClose: (tags: string[]) => void
}


function ModalSelector(props: modalPTTagsSelectorProps) {
  const [search, setSearch] = useState('')
  const loading = useLoading()


  const getItems = () => {

    let ret : MenuProps['items'] = [];
    ret.push({
      label: 'Add',
      key: 'add',
      icon: <PlusOutlined />}
    );
    ret.push({
      label: 'Remove',
      key: 'remove',
      icon: <MinusOutlined/>
    });
    return ret;

  }
  const [current, setCurrent] = useState('add');

  const [addValue, setAddValue] = useState('')
  const [addTagOptions, setAddTagOptions] = useState<string[]>([]
  )

  const [removeTagOptions, setRemoveTagOptions] = useState<string[]>([]
  )
  const getTagInUse = (name: string) => {
    let retVal = false
    if (props.allTags) {
      props.allTags.forEach(function (tag) {
        if (tag.toLowerCase() === name.toLowerCase()) {
          retVal = true
        }
      })
    }
    return retVal
  }

  // @ts-ignore
  const filteredAddOptions = addTagOptions.filter(option => option.toLowerCase().includes(search.toLowerCase()))
  // @ts-ignore
  const filteredRemoveOptions = removeTagOptions && removeTagOptions.filter(option => option.toLowerCase().includes(search.toLowerCase()))
  // @ts-ignore
  const filteredDeleteOptions = addTagOptions.filter(option => option.toLowerCase().includes(search.toLowerCase())  && !getTagInUse(option) )



  useEffect(() => {
    (async() =>{
      loading.addLoading()
      const res = await getAllTags()
      if (res) {
        setAddTagOptions(res.tags)
      }
      loading.removeLoading()
    })()
  }, [])

  useEffect(() => {
    (async() =>{
      console.log("Setting current to add")
      setCurrent('add')
      setRemoveTagOptions(props.tags)
    })()
  }, [props.visible])



  const saveNewTag = async (option: string) => {
    const res = await addTag(option)
    if (res) {
      setAddTagOptions(res.tags)
    }
    setAddValue('')
  }



  const deleteTagLocal = async (name: string) => {
    const res = await deleteTag(name)
    if (res)
      setAddTagOptions(res.tags)
  }

  useEffect(() => {
    console.log("removeTagOptions" + JSON.stringify(removeTagOptions))
  }, [removeTagOptions])

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key);
  };
  const getTagInUseForTitle = (name: string) => {
    let retVal = false
    if (removeTagOptions) {
      removeTagOptions.forEach(function (tag) {
        if (tag.toLowerCase() === name.toLowerCase()) {
          retVal = true
        }
      })
    }
    return retVal
  }
  const addTagToTitle = (name : string) => {
    console.log("Entering addTagToTitle")
    let tags : string[] = []
    let found = false
    if (removeTagOptions) {
      removeTagOptions.forEach(function (tag) {
        tags.push(tag)
        if (tag.toLowerCase() === name.toLowerCase()) {
          found = true
        }
      })
    }
    if (!found){
      console.log("Adding Tag")
      tags.push(name)
      setRemoveTagOptions(tags)
    }

  }

  const removeTagFromTitle = (name : string) => {
    console.log("Entering removeTagFromTitle")
    let tags : string[] = []
    let found = false
    if (removeTagOptions) {
      removeTagOptions.forEach(function (tag) {
        if (tag.toLowerCase() === name.toLowerCase()) {
          found = true
        } else {
          tags.push(tag)
        }
      })
    }
    if (!found){
      console.log("Tag not found")
    } else {
      setRemoveTagOptions(tags)
    }

  }
  const getActionButtons = (name: string) => {
    return(
        <div className="cashiers__table__actions">
          <Button
              onClick={() => addTagToTitle(name)}
              type='secondary'
              style={{backgroundColor: '#2fa4e7'}}
              disabled={getTagInUseForTitle(name)}
          >
            <PlusOutlined style={{ fontSize: '16px', color: '#FFF' }} />
          </Button>
        </div>
    )
  }

  const getRemoveActionButtons = (name: string) => {
    return(
        <div className="cashiers__table__actions">
          <Button
              onClick={() => removeTagFromTitle(name)}
              type='secondary'
              style={{backgroundColor: '#2fa4e7'}}
          >
            <MinusOutlined style={{ fontSize: '16px', color: '#FFF' }} />
          </Button>
        </div>
    )
  }

  const getDeleteActionButtons = (name: string) => {
    return(
        <div className="cashiers__table__actions">
          <Button
              onClick={() => deleteTagLocal(name)}
              type='secondary'
              style={{backgroundColor: 'red'}}
          >
            <DeleteOutlined style={{ fontSize: '16px', color: '#FFF' }} />
          </Button>
        </div>
    )
  }

  const onClose = () => {
    console.log("Entering onClose")
    props.onClose(removeTagOptions)
  }

  return (
    <>
        <Modal open={props.visible} title={props.title} onCancel={onClose} onOk={onClose}
               cancelButtonProps={{ style: { display: 'none' } }}
               okButtonProps={{ style: { display: 'none' } }}
               style={{height: '80%'}}
        >
          <div className="modal-selector">
            <Menu style={{ backgroundColor: 'transparent' }} onClick={onClick} selectedKeys={[current]} mode="horizontal" items={getItems()} />


            {current === 'add' &&
            <>
            <div className="modal-selector__search" >
              <Input
                  label="Filter"
                  value={search}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                  placeholder="Type to search"
              />

            </div>
            <div className="modal-selector__options">
              <p>{props.tags}</p>
              <List

                  rows={filteredAddOptions}
                  columns={[
                    {
                      title: 'Actions',
                      dataIndex: '',
                      key: '',
                      render: (value: string) => getActionButtons(value),
                      width: 50
                    },

                    {
                      title: 'Tag',
                      dataIndex: '',
                      key: '',
                      sorter: (a: any, b: any) => stringCompare(a, b),
                    },
                  ]}
              />
            </div>
            * Disabled add button denotes tab has the tag already, otherwise the tab does not have the tag

            </>
        }
            {current === 'remove' &&
                <>
                  <div className="modal-selector__search" >
                    <Input
                        label="Filter"
                        value={search}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                        placeholder="Type to search"
                    />

                  </div>
                  <div className="modal-selector__options">
                    <List

                        rows={filteredRemoveOptions}
                        columns={[
                          {
                            title: 'Actions',
                            dataIndex: '',
                            key: '',
                            render: (value: string) => getRemoveActionButtons(value),
                            width: 50
                          },

                          {
                            title: 'Tag',
                            dataIndex: '',
                            key: '',
                            sorter: (a: any, b: any) => stringCompare(a, b),
                          },
                        ]}
                    />
                  </div>
                  * Only shows tags in use with this tab
                </>
            }
            {current === 'delete' &&
                <>
                  <h4>This will permanently remove the tag from the system.
                    If a tag you wish to delete is not in this list, it is attached to a tab and must be removed first.</h4>
                  <div className="modal-selector__search" >
                    <Input
                        label="Filter"
                        value={search}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                        placeholder="Type to search"
                    />

                  </div>
                  <div className="modal-selector__options">
                    <List

                        rows={filteredDeleteOptions}
                        columns={[
                          {
                            title: 'Actions',
                            dataIndex: '',
                            key: '',
                            render: (value: string, record: any) => getDeleteActionButtons(value),
                            width: 50
                          },

                          {
                            title: 'Tag',
                            dataIndex: '',
                            key: '',
                            sorter: (a: any, b: any) => stringCompare(a, b),
                          },
                        ]}
                    />
                  </div>
                </>
            }
          </div>
        </Modal>
    </>
  )
}

export default ModalSelector
